module.exports = "<div class=\"report-grid-square {{ $ctrl.colorClass}} {{$ctrl.optionalClass}}\" title=\"{{ $ctrl.hoverText }}\"> <i class=\"fa {{ $ctrl.icon }}\"></i> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/common/report-grid-square/report-grid-square.html
// module id = 359
// module chunks = 0